import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material';
import { getStoredPixelConsent } from '../PixelConsentOverlay';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Milk",
  "Egg",
  "Peanuts",
  "Nuts",
  "Gluten",
  "Crustaceans",
  "Pisces",
  "Soja",
  "Sesame seeds",
  "Mustard",
  "Celery",
  "Sulphurous anhydrous",
  "Molluscs",
  "Lupine",
  "Cereals",  
];

export default function AllergensSelect(props) {
  const [allergens, setAllergens] = React.useState(props.initialValue || []);
  const { t } = useTranslation();

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    const selectedAllergens = typeof value === 'string' ? value.split(',') : value;
    
    // Trier les allergènes selon l'ordre du tableau names
    const sortedAllergens = names.filter(name => selectedAllergens.includes(name));
    
    setAllergens(sortedAllergens);

    if (props.callback){                 
        props.callback(sortedAllergens.toString());
    }
  };

  const handleClose = () => {
    if (getStoredPixelConsent() === 'accepted') {
      if (window.ttq){
        window.ttq.track('AllergensSelected');
      }
      if (window.fbq){                    
          window.fbq('trackCustom', 'AllergensSelected');
      }
    }
  };

  return (
    <div>
      <ThemeProvider theme={createTheme({
        palette: {
          primary: {
            main: props.color,
          },    
        },
      })}>
        <FormControl sx={props.fromMenuEditor ? { width: "100%", maxWidth: 300, m: 0 } : { m: 1, width: 300 }}>
          <InputLabel id="allergens-select-label">{t("Allergens")}</InputLabel>
          <Select
            labelId="allergens-select-label"
            id="allergens-select"
            multiple
            value={allergens}
            onTouchStart={(e)=>e.stopPropagation()}
            onTouchMove={(e)=>e.stopPropagation()}
            onTouchEnd={(e)=>e.stopPropagation()}
            onChange={handleChange}
            onClose={handleClose}
            input={<OutlinedInput label="Tag" />}
            renderValue={(selected) => selected.map((value) => t(value)).join(', ')}
            MenuProps={MenuProps}          
          >
            {names.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={allergens.indexOf(name) > -1} />
                <ListItemText primary={t(name)} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </ThemeProvider>
    </div>
  );
}